import createDataContext from './createDataContext'

const noteReducer = (state, action) => {
  switch (action.type) {
    case 'AFFILIATION_NOTE:FETCH_STARTED':
      return { ...state, isLoading: true, failed: false }
    case 'AFFILIATION_NOTE:FETCH_RECEIVED':
      return {
        ...state,
        isLoading: false,
        notes: action.payload.notes || [],
        total: action.payload.total || 0,
        self: action.payload.self,
        next: action.payload.next,
        prev: action.payload.prev,
      }
    case 'AFFILIATION_NOTE:SET_PAGE':
      return { ...state, page: action.payload.page }
    case 'AFFILIATION_NOTE:SET_ROWS_PER_PAGE':
      return { ...state, page: action.payload.page, rowsPerPage: action.payload.rowsPerPage }
    case 'AFFILIATION_NOTE:FAILED':
      throw action.payload
    default:
      throw new Error(`Unsupported action type: ${action.type}`)
  }
}

const initialState = {
  notes: [],
  links: null,
  total: 0,
  rowsPerPage: 25,
  page: 0,
  self: null,
  next: null,
  prev: null,
  isLoading: false,
  failed: false,
}

export const { Provider, Context } = createDataContext(noteReducer, initialState)
